/**
 * TimedStepExtraFieldType - ExtraField pour les étapes avec timer
 * Identique à Java TimedStepExtraField
 */

import {ExtraFieldType} from '../../types/ExtraFieldType';
import {GameDataExtraField} from '../../../models/GameDataExtraField';

export class TimedStepExtraFieldType implements ExtraFieldType {
  typeName = 'TIMED';
  messageKey = 'laventurier.ESCAPE.extrafield.TIMED.name';
  descriptionKey = 'laventurier.ESCAPE.extrafield.TIMED.desc';
  errorKey = 'laventurier.ESCAPE.extrafield.TIMED.error';
  hasValue = true;
  isHidden = true; // Champ caché dans l'éditeur
  defaultValue = '0';
  valueRegexp = '^[0-9]+$'; // NUMERIC

  process(field: GameDataExtraField, gameState: any): void {
    // Le timer est géré par les widgets d'étape
    // Cette méthode peut être utilisée pour initialiser ou valider la valeur
    if (!field.currentValue) {
      field.currentValue = parseInt(field.initValue || this.defaultValue, 10);
    }
  }
}
